import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
export default {
  name: 'service-template-list',
  components: {pageheader},
  data () {
    return {
      input: {},
      isLoading: false,
      serviceTemplateList: [],
      search: "",
      pageSize: "",
      headers: [
        { text: '#', value: 'sno'},
        { text: 'Name', value: 'name'},
        { text: 'Description', value: 'description',width: '500px'},
        { text: 'Trigger', value: 'triggerValue'},
        { text: 'Linked Actions', value: 'linkedActions'},
        { text: 'Actions', value: 'action'},
      ],
      isFilter: false,
      deleteDialog: false,
      deleteID: "",
      deleteServiceTemplateName: "",
      warningFromAPI: "",
      isDelete: false,
    }
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  filters: {
    numberFormat: function(value){
      if(value != 'Quarterly' || value != 'Monthly' || value != 'yearly'){
        return Number(value).toLocaleString();
      }
    },
  },
  mounted () {
    this.input = utils.getInputContent("serviceTemplateManagement", this.roles);
    if(this.$route.query && this.$route.query.isFilter){
      this.search = this.$route.query.filterVal;
      this.isFilter = this.$route.query.isFilter;
    }
    this.getServiceTemplateList();
  },
  methods: {
    createNewServicetemplate(){
      this.$router.push({ name: 'Create Service Templates', params: { type: 'add'}})
    },
    async getServiceTemplateList(){
      this.isLoading = true;
      try{
        let response = await telematicsService.getServiceTemplateList();
        if(response.isSuccess){
          this.isLoading = false;
          this.serviceTemplateList = response.data.map((d, index) => ({ ...d, sno: index + 1,emailsList:d['customEmailIds'].split(',') }));
        }else{
          this.isLoading = false;
          this.serviceTemplateList = [];
        }
      }catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    editServiceTemplate(item){
      if(this.isFilter){
      this.$router.push({ name: 'Update Service Templates', params: { type: 'edit', id : item.id},query: {filterVal: this.search, isFilter: this.isFilter}});
      }else{
        this.$router.push({ name: 'Update Service Templates', params: { type: 'edit', id : item.id},query: {filterVal: '', isFilter: this.isFilter}});
      }
    },
    onSearch(){
      if(this.search){
        this.isFilter = true;
      }else{
        this.isFilter = false;
      }
    },
    clearSearch(){
      this.search = "";
      this.$router.replace(`/service-template-management`);
      this.getServiceTemplateList();
    },
    openDeleteDialog(item){
      this.deleteDialog = true;
      this.deleteID = item.id;
      this.deleteServiceTemplateName = item.name;
      this.warningFromAPI = "";
    },
    cancelDelete(){
      this.deleteDialog = false;
      this.deleteID = "";
      this.deleteServiceTemplateName = "";
      this.warningFromAPI = "";
    },
    async deleteTemplate() {
      try {
        this.isDelete = true;
        let response = await telematicsService.removeServiceTemplate(this.deleteID);
        if (response.isSuccess) {
          this.isDelete = false;
          this.$toast.success("Service template deleted successfully");
          this.warningFromAPI = "";
          this.cancelDelete();
          this.getServiceTemplateList();
        }else{
          this.warningFromAPI = response.systemMessage;
        }
      } catch (err) {
        this.isDelete = false;
        this.$toast.error("Unable to delete the service template" + err);
        this.cancelDelete();
      }
    },
    routeToUnlinkService(deleteID){
      this.$router.push({name: "Add New Service", params: {ID: deleteID}});
    }
  }
}


